import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WorkItem } from '@rapider/sdk';

export interface WorkItemFilters {
  kind?: string;
  applicationId?: string;
}

export const WorkitemsActions = createActionGroup({
  source: 'Workitems',
  events: {
    // Loading workitems list with pagination (last 20 items) and necessary fields
    'Load Workitems': props<{ filters?: WorkItemFilters }>(),
    'Load Workitems Success': props<{ workitems: WorkItem[] }>(),
    'Load Workitems Failure': props<{ error: string }>(),

    // Selecting a workitem and loading full detail
    'Select Workitem': props<{ id: string }>(),
    'Load Workitem Detail': props<{ id: string }>(),
    'Load Workitem Detail Success': props<{ workitem: WorkItem }>(),
    'Load Workitem Detail Failure': props<{ id: string; error: string }>(),

    // Updating status (optimistic with server sync)
    'Update Workitem Status': props<{ id: string; status: string }>(),
    'Update Workitem Status Success': props<{ id: string; status: string }>(),
    'Update Workitem Status Failure': props<{ id: string; error: string; previousStatus: string }>(),

    // Clear state on workspace change
    'Clear Workitems': emptyProps(),
  },
});
